<template>
  <v-container>
    <!--  表单标题   -->
    <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218); height: 10px;" class="ml-4 mt-3">通用设备点检填报
      <v-icon></v-icon>
    </p>
    <span class="ml-4" style="color:rgb(132, 132, 132); font-size: 12px;">根据消防点检情况进行填写</span>
    <div>
      <!--  表单标题   -->
      <v-form ref="form" v-model="isValid" class="mt-4">
        <v-card-text>
          <v-row>

            <!-- 设备类型（下拉框） -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-select dense v-model="formData.check_type" :items="deviceOptions" label="请选择设备类型"
                :rules="requiredRules" required hint="请选择设备类型">
              </v-select>
            </v-col>

            <!-- 设备结果状态 -->
            <v-col cols="12" class="mt-1"
              style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
              <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px; padding: 0;">设备状态 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-radio-group v-model="formData.check_status" label="" :rules="requiredRules" required row
                class="d-flex align-center">
                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;" label="正常"
                  value="正常"></v-radio>
                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;" label="异常"
                  value="异常"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- 设备数 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
              class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备数量 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.check_number" label="请输入巡检设备数" type="number" :rules="countRules" required
                hint="请输入同一类型设备点检数量"></v-text-field>
            </v-col>

            <!-- 巡检楼栋 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
              class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检楼栋 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.check_buliding" label="请输入巡检楼栋" :rules="requiredRules" required
                hint="请输入巡检楼栋"></v-text-field>
            </v-col>

            <!-- 巡检楼层 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
              class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检楼层 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.check_floor" label="请输入巡检楼层" :rules="requiredRules" required
                hint="请输入巡检楼层"></v-text-field>
            </v-col>

            <!-- 设备描述 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">详情描述 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-textarea v-model="formData.check_description" label="点检异常补充说明" :rules="requiredRules" required
                hint="请输入设备描述"></v-textarea>
            </v-col>


            <!-- 上传现场图片 -->
            <v-col cols="12" sm="6" md="4" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">上传附件 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-file-input v-model="check_attachment" label="上传现场图片" accept="image/*" required hint="支持上传图片、PDF、Word文档"
                @change="uploadImage(check_attachment)" :rules="[v => !!v || '请上传一张图片']">
                <!-- @update:model-value="handleFileInput" -->
              </v-file-input>
              <v-img v-if="imageUrl" :src="imageUrl" aspect-ratio="1" class="mt-4" max-width=""></v-img>
            </v-col>


            <!-- 巡检人员标题 -->
            <v-col class="d-flex align-center float-left mt-4" style="height:40px;">
              <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218);">
                <v-icon style="color: rgb(50,134,218);">mdi-account-circle</v-icon>
                巡检人员信息
              </p>
            </v-col>

            <!-- 巡检人 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查人员 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.check_staff" label="请输入巡检人名称" :rules="requiredRules" required
                hint="请输入巡检人名称"></v-text-field>
            </v-col>

            <!-- 巡检部门 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
              class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查部门 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.check_department" label="请输入巡检部门/组" :rules="requiredRules" required
                hint="请输入巡检部门/组"></v-text-field>
            </v-col>

            <!-- 巡检时间 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
              class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查时间 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-text-field v-model="formData.check_date" label="" readonly hint="自动填充当前时间"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <!-- <v-spacer></v-spacer>   -->
          <v-btn color="success" dark @click="resetForm">重置</v-btn>
          <v-btn color="blue darken-1" dark @click="submitForm">提交</v-btn>
        </v-card-actions>
      </v-form>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'abnormalView',
  data() {
    return {
      isValid: false,                 // 填报的报表装填

      formData: {
        check_type: '',               // 设备类型
        check_status: '',             // 设备状态反馈 
        check_number: '',             // 设备点检数量
        check_buliding: '',           // 设备楼宇
        check_floor: '',              // 设备楼层
        check_description: '',        // 设备描述
        check_attachment: null,       // 点检附件（图片）
        check_staff: '',              // 点检人员
        check_department: '',         // 点检部门
        check_date: ''                // 点检时间 (初始化页面时自动填充当前时间)
      },
      imageUrl: null,
      deviceOptions: ['灭火器', '消防栓', '烟感设备', '手报设备', '防火卷帘', '应急设备', '排烟设备'],    // 设备类型下拉选项框内容
      requiredRules: [v => !!v || '该字段是必填项'],                                                   // 进行数据正则验证(数据内容必填)
      countRules: [v => !!v || '该字段是必填项', v => /^\d+$/.test(v) || '请输入有效的数字']             // 进行报表数值类型正则验证(保证填报时只能填报数值)
    }
  },
  mounted() {
    // 界面初始化进行实例的数据/函数  
    this.initializeTime();
  },

  // 函数/事件
  methods: {
    async initializeTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const formattedMonth = month < 10 ? '0' + month : month.toString();
      const formattedDay = day < 10 ? '0' + day : day.toString();
      const formattedHours = hours < 10 ? '0' + hours : hours.toString();
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
      const formattedSeconds = seconds < 10 ? '0' + seconds : seconds.toString();
      const formattedDateTime = `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      this.formData.check_date = formattedDateTime;
      return formattedDateTime;

    },

    // 执行表单提交填报
    async submitForm() {
      console.log('填报的数据信息', this.formData);
      if (this.isValid) {
        try {
          await this.submitFormData();
          this.showSucceSnackbar("填报成功。");
        } catch (error) {

        }

      }
    },

    // 拼接图片和字段文本内容直接提交
    async submitFormData() {
      try {
        // const imageUrl = await this.uploadImage(this.formData.abnormal_attachment);
        const textData = {
          check_type: this.formData.check_type,
          check_status: this.formData.check_status,
          check_number: this.formData.check_number,
          check_buliding: this.formData.check_buliding,
          check_floor: this.formData.check_floor,
          check_description: this.formData.check_description,
          check_attachment: this.imageUrl,
          check_staff: this.formData.check_staff,
          check_department: this.formData.check_department,
          check_date: this.formData.check_date,
        };
        console.log('拼接表单字段内容', textData);
        const jsonData = JSON.stringify(textData);

        console.log(jsonData);
        const response = await fetch('http://192.168.3.3:18081/check/addCheckGeneral', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: jsonData,
        });
        if (!response.ok) {
          throw new Error("提交失败!");
        }
        console.log("提交成功!");
        this.$router.push("/logoView");


      } catch (error) {
        console.error('提交过程中发生错误：', error);
        this.showErrorSnackbar('提交失败，请检查网络或数据格式');
      }
    },


    // 上传图片,回传保存后的图片Url
    async uploadImage(check_attachment) {
      const formData = new FormData();
      const file = check_attachment;
      console.log("上传图片获取的地址", file)
      if (file) {
        formData.append('check_attachment', file);
      }
      try {
        const response = await fetch('http://192.168.3.3:18081/check/files/upload/image', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          throw new Error('图片上传失败!');
        }

        const data = await response.json();
        const userData = data.data;
        this.imageUrl = userData;
        console.log("图片上传成功,地址:", this.imageUrl);
        return this.imageUrl;
      } catch (error) {
        console.error("图片上传失败!", error);
        throw error;
      }

    },

    // 上传表单文本
    // async submiTextData(textData) {
    //   const jsonData = JSON.stringify(textData);
    //   console.log(jsonData);
    //   const response = await fetch('http://127.0.0.1:18080/abnormal/addAbnormal', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: jsonData,
    //   });
    //   console.log(response);
    //   // return response;
    // },

    // 进行重置填报表单
    async resetForm() {
      // 根据表ref标签进行重置表单
      // this.$refs.form.reset()
      const currentTime = await this.initializeTime();
      this.formData = {
        check_type: '',
        check_status: '',
        check_number: '',
        check_buliding: '',
        check_floor: '',
        check_description: '',
        check_attachment: null,
        check_staff: '',
        check_department: '',
        check_date: currentTime,
      },
        this.imageUrl = null;

    }
  }

}

</script>